export function trans(value) {
	let translations = {
		users: 'Utenti',
		user: 'Utente',
		products: 'Trattamenti',
		product: 'Trattamento',
		categories: 'Categorie',
		categoy: 'Categoria',
		tasks: 'Task',
		task: 'Task',
		tasklists: 'Tasklist',
		tasklist: 'Tasklist',
		calendar: 'Calendario',
		dashboard: 'Dashboard',
		customer: 'Cliente',
		customers: 'Clienti',
		new_customer: 'Nuovo Cliente',
		settings: 'Impostazioni',
		true: 'Attiva',
		false: 'Disattiva',
		productcategories: 'Categorie Trattamenti',
		productcategory: 'Categoria Trattamento',
		new_productcategory: 'Nuova Categoria Trattamento',
		new_product: 'Nuovo Trattamento',
		new_task: 'Nuovo Task',
		new_user: 'Nuovo Utente',
		fidelitycard: 'Carta Fedeltà',
		fidelitycards: 'Carte Fedeltà',
		new_fidelitycard: 'Nuova Carta Fedeltà'
	}

	return translations[value]
}
